import { SSO } from "../../common/apiUrl/sso/ssoUrl";
import { API } from "../../common/model/objectTypes";
import { organizerDeliveredInfo } from "../../utils/apiDescription/sso/delivered";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";
import { deliveredOrganizerParameter, deliveredOrganizerResponseBody, deliveredSignerDetailsRequestParameter, organizerCommonRequestBody, organizerSendReminderRequestBody, resendAccessLinkRequestBody, signerDetailsResponseBody } from "../../utils/sso/apiObjects";
import { archiveOrganizerDeliveredJsonRequestCurl, deleteOrganizerDeliveredJsonRequestCurl, deliveredOrganizerJsonRequestCurl, deliveredResendAccessLinkJsonRequestCurl, deliveredSignerDetailsJsonRequestCurl, sendReminderLinkJsonRequestCurl } from "../../utils/sso/sampleJsonRequest";
import { deliveredOrganizerJsonResponse, signerDetailsJsonResponse } from "../../utils/sso/sampleJsonResponse";


const archiveOrganizer: API = {
    name: "Archive Organizer",
    url: `${API_BASE_URL}/${SSO.DELIVERED.ARCHIVE_ORGANIZER_URL}`,
    method: "PUT",
    headers: requestHeaderWithCallback,
    apiInfo: organizerDeliveredInfo.archiveOrganizer,
    requestBody: organizerCommonRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: archiveOrganizerDeliveredJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
}
const deleteOrganizer: API = {
    name: "Delete Organizer API",
    url: `${API_BASE_URL}/${SSO.DELIVERED.DELETE_ORGANIZER_URL}`,
    method: "DEL",
    headers: requestHeaderWithCallback,
    apiInfo: organizerDeliveredInfo.deleteOrganizer,
    requestBody: organizerCommonRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: deleteOrganizerDeliveredJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(202),
}
const deliveredOrganizer: API = {
    name: "Delivered Organizer API",
    url: `${API_BASE_URL}/${SSO.DELIVERED.DELIVERED_ORGANIZER_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: organizerDeliveredInfo.deliveredOrganizer,
    requestBody: deliveredOrganizerParameter,
    responseBody: deliveredOrganizerResponseBody,
    jsonRequest: deliveredOrganizerJsonRequestCurl,
    jsonResponse: deliveredOrganizerJsonResponse,
}
const resendAccessLink: API = {
    name: "Resend Access Link",
    url: `${API_BASE_URL}/${SSO.DELIVERED.RESEND_ACCESS_LINK_URL}`,
    method: "POST",
    headers: commonRequestHeader,
    apiInfo: organizerDeliveredInfo.resendAccessLink,
    requestBody: resendAccessLinkRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: deliveredResendAccessLinkJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}
const sendReminder: API = {
    name: "Send Reminder Api",
    url: `${API_BASE_URL}/${SSO.DELIVERED.SEND_REMINDER_URL}`,
    method: "POST",
    headers: commonRequestHeader,
    apiInfo: organizerDeliveredInfo.sendReminder,
    requestBody: organizerSendReminderRequestBody,
    responseBody: commonResponseBody,
    jsonRequest: sendReminderLinkJsonRequestCurl,
    jsonResponse: createCommonJsonResponseWithData(200),
}
const signerDetails: API = {
    name: "Signer Details",
    url: `${API_BASE_URL}/${SSO.DELIVERED.SIGNER_DETAILS_URL}`,
    method: "GET",
    headers: commonRequestHeader,
    apiInfo: organizerDeliveredInfo.signerDetails,
    requestBody: deliveredSignerDetailsRequestParameter,
    responseBody: signerDetailsResponseBody,
    jsonRequest: deliveredSignerDetailsJsonRequestCurl,
    jsonResponse: signerDetailsJsonResponse,
}

export const getContent = (apiName :string) => {    
    switch (apiName) {
        case 'Archive Organizer':
            return archiveOrganizer;
        case 'Delete Organizer API':
            return deleteOrganizer;
        case 'Delivered Organizers':
            return deliveredOrganizer;
        case 'Resend Access Link':
            return resendAccessLink;
        case 'Signer Details':
            return signerDetails;
        case 'Send Reminder API':
            return sendReminder;
    }
}